import { MobileBottomLayout } from '~/layout/mobile-bottom'
import { Route } from '~/routes/_main-layout/settings/subscription/change-payment-method'

import { ChangePaymentMethodForm } from '../components/change-payment-method-form'
import { StripeElements } from '../components/stripe-elements'

export const ChangePaymentMethodPage = () => {
  const { clientSecret } = Route.useSearch()

  if (!clientSecret) return null

  return (
    <StripeElements clientSecret={clientSecret}>
      <MobileBottomLayout className="w-[90vw] max-w-3xl">
        <ChangePaymentMethodForm />
      </MobileBottomLayout>
    </StripeElements>
  )
}
